const languages = {
  es: { label: 'ESP', flag: require('../images/flag_es.svg') },
  en: { label: 'EN', flag: require('../images/flag_en.svg') },
  ca: { label: 'CAT', flag: require('../images/flag_ca.svg') },
  fr: { label: 'FRA', flag: require('../images/flag_fr.svg') },
  pt: { label: 'POR', flag: require('../images/flag_pt.svg') },
};

export default languages;
